import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test211225 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 21/12/2025 Results</h3>
      <br />
      <br />


      <div><Link to='/conduct-ekasitw'>1. AAT  1187  MR.EKASIT WIPULANUSAT(PASS with Distinction)---Accquired Rank SHODAN-HO</Link></div>
      <br />
        <div><Link to='/conduct-santis'>2. AAT  7518  MR.SANTI SIRISAK(PASS with Distinction)---Accquired Rank SHODAN-HO**</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>3. ATT  7731  MS.PAWANRAT CHUPINIJSAK(PASS with Distinction)---Accquired Rank SHODAN-HO**</Link></div>
        <br />
        <div><Link to='/conduct-niwats'>4. ATT  6670  MR.NIWAT SEESANGNGAM(PASS with Distinction)---Accquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-thakhunk'>5. AAT  6514  MR.THAKHUN KAEWISALAPRAN(PASS with Distinction)---Accquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>6. AAT  7369  MR.JACQUES DU PLESSIS(PASS with Distinction)---Accquired Rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>7. AAT  7847  MR.WANNATOUCH PRASERT(PASS with Distinction)---Accquired Rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-anantayak'>8. ATT  7749  MS.ANANTAYA KULTANAKORN(PASS with Distinction)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>9. AAT  8007  MR.KARNT SRISUWAN(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>10. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(PASS)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-sirawichu'>11. AAT  8015  MR.SIRAWICH UDOMKANA(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>12. AAT  8021  MS.VU NGUYEN QUYNH TRAM(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nattawuta'>13. AAT  6233  MR.NATTAWUT ASSARASRI(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-narat'>14. AAT  8033  MS.NARA TAKIGUCHI(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>15. AAT  8038  MR.PRAPHATPONG YOODEE(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-nichaj'>16. AAT  8039  MS.NICHA JAMJUN(PASS)---Accquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-naras'>17. AAT  8040  MR.NARA  SINGHSATHITSUK(NO-SHOW)---Accquired Rank N/A</Link></div>
        <br />







        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test211225;
